/**
 * API endpoint configuration
 * Automatically selects staging or live based on REACT_APP_API environment variable
 */

const LIVE = {
  api: 'https://cdn.expostudio.co',
  web: 'https://www.expostudio.co',
  apiOrigin: 'https://cdn.origin.expostudio.co',
  cms: 'https://cms.expostudio.co',
  socket: 'https://socket.expostudio.co',
  media: 'https://www.expostudio.co/media/',
};

const STAGING = {
  api: 'https://cdn.staging.expostudio.co',
  web: 'https://staging.expostudio.co',
  apiOrigin: 'https://cdn.staging.origin.expostudio.co',
  cms: 'https://cms.staging.expostudio.co',
  socket: 'https://socket2.expostudio.co',
  media: 'https://staging.expostudio.co/media/',
};

// Determine environment from REACT_APP_API (set by build scripts)
const isLive = process.env.REACT_APP_API?.includes('cdn.expostudio.co') &&
               !process.env.REACT_APP_API?.includes('staging');

const isDevelopment = process.env.NODE_ENV === 'development';

// Select endpoint set based on environment
const endpoints = isLive ? { ...LIVE } : { ...STAGING };

// Override socket URL in development
if (isDevelopment) {
  endpoints.socket = 'localhost:3001';
}

// Export environment detection for use elsewhere
export const environment = {
  isLive,
  isStaging: !isLive,
  isDevelopment,
  name: isLive ? 'live' : 'staging',
};

export default endpoints;
